// Vendor libraries
import { ChangeDetectorRef, ElementRef } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
// Constants
import { QUICKFLOWS_MENU_ON_SINGLE_SECURITY_TAB_COOKIE_NAME } from 'QuickflowsApp/ts/constants';
// Services
import { UrlsService } from 'NewAngular/services/core/urls.service';
// Components
import { SingleSelectQuickflowsComponent } from './single-select-quickflows.component';
import { MultiSelectQuickflowsComponent } from './multi-select-quickflows.component';
import * as i0 from "@angular/core";
import * as i1 from "ngx-cookie-service";
import * as i2 from "NewAngular/services/core/urls.service";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i5 from "../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i6 from "QuickflowsApp/ts/features/quickflows-menu/components/multi-select-quickflows.component";
import * as i7 from "./single-select-quickflows.component";
const _c0 = () => ({ paddingLeft: "5px" });
const _c1 = a0 => ({ active: a0 });
/**
 *
 * Quickflows Menu Component
 *
 * The quickflows menu that lives on the right hand side of the screen.
 * Controls the single select and multi select quickflow tabs.
 *
 * Input Properties:
 *   displaySecurityId: The display security ID to initialize this component with, e.g. VTSAX
 *   securityId: The security ID to initialize this component with, e.g. M:VTSAX
 *
 */
export class QuickflowsMenuComponent {
    constructor(changeDetector, eltRef, cookieService, urlsService) {
        this.changeDetector = changeDetector;
        this.eltRef = eltRef;
        this.cookieService = cookieService;
        this.urlsService = urlsService;
        this.isMenuOpened = false;
        this.showSingleSecurityQuickflowsTab = true;
        this.userPreferencesUrl = '';
        this.displaySecurityId = this.eltRef.nativeElement.getAttribute('displaySecurityId');
        this.securityId = this.eltRef.nativeElement.getAttribute('securityId');
        this.securityName = this.eltRef.nativeElement.getAttribute('securityName');
        this.securityUrl = this.eltRef.nativeElement.getAttribute('securityUrl');
    }
    ngOnInit() {
        this.setQuickflowMenuTab();
        this.userPreferencesUrl = this.urlsService.ACCOUNTS.USER_PREFERENCE_SETTINGS;
    }
    ngAfterViewInit() {
        // Disable change detection until toggled open
        this.changeDetector.detach();
    }
    setQuickflowMenuTab() {
        const onSingleSecurityTabCookie = this.cookieService.get(QUICKFLOWS_MENU_ON_SINGLE_SECURITY_TAB_COOKIE_NAME);
        if (onSingleSecurityTabCookie) {
            this.showSingleSecurityQuickflowsTab = JSON.parse(onSingleSecurityTabCookie);
        }
    }
    setQuickflowMenuTabCookie() {
        this.cookieService.set(QUICKFLOWS_MENU_ON_SINGLE_SECURITY_TAB_COOKIE_NAME, this.showSingleSecurityQuickflowsTab.toString(), { path: '/' });
    }
    focusOnSecurityInput() {
        setTimeout(() => {
            if (this.showSingleSecurityQuickflowsTab && this.singleSelectTab) {
                this.singleSelectTab.focusAutocompleter();
            }
            else if (!this.showSingleSecurityQuickflowsTab && this.multiSelectTab) {
                this.multiSelectTab.focusAutocompleter();
            }
        });
    }
    toggleQuickflowTab() {
        this.showSingleSecurityQuickflowsTab = !this.showSingleSecurityQuickflowsTab;
        this.setQuickflowMenuTabCookie();
        this.focusOnSecurityInput();
    }
    toggleOpenClose() {
        this.isMenuOpened = !this.isMenuOpened;
        if (this.isMenuOpened) {
            // Enable change detection because the menu is being toggled open
            this.changeDetector.reattach();
            this.changeDetector.detectChanges();
            this.setQuickflowMenuTab();
            this.focusOnSecurityInput();
        }
        else {
            this.changeDetector.detectChanges();
            // We don't need to run change detection in any of the quickflows components
            // while the menu is closed
            this.changeDetector.detach();
        }
    }
}
QuickflowsMenuComponent.ɵfac = function QuickflowsMenuComponent_Factory(t) { return new (t || QuickflowsMenuComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.CookieService), i0.ɵɵdirectiveInject(i2.UrlsService)); };
QuickflowsMenuComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: QuickflowsMenuComponent, selectors: [["ycn-quickflows-menu"]], viewQuery: function QuickflowsMenuComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(MultiSelectQuickflowsComponent, 5);
        i0.ɵɵviewQuery(SingleSelectQuickflowsComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.multiSelectTab = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.singleSelectTab = _t.first);
    } }, inputs: { displaySecurityId: "displaySecurityId", securityId: "securityId", securityName: "securityName", securityUrl: "securityUrl" }, decls: 24, vars: 26, consts: [[1, "btn", "quickflows-toggler", 3, "click", "hidden"], ["ycnIcon", "", 3, "name"], [1, "quickflows", "open", 3, "hidden"], [1, "quickflows-header"], [1, "quickflows-title"], ["ycnTooltip", "", 1, "nav-link", 3, "href", "tooltipTitle"], ["ycnIcon", "", 1, "icon-gear", 3, "name"], [1, "quickflows-close", 3, "click"], [1, "panel-quickflows"], [1, "tabs"], [1, "nav", "nav-tabs", "nav-width-equal"], [1, "nav-item"], ["href", "javascript:void(0)", 1, "nav-link", 3, "click", "ngClass"], [3, "hidden", "displaySecurityId", "securityId", "securityName", "securityUrl"]], template: function QuickflowsMenuComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div")(1, "div", 0);
        i0.ɵɵlistener("click", function QuickflowsMenuComponent_Template_div_click_1_listener() { return ctx.toggleOpenClose(); });
        i0.ɵɵelementStart(2, "span");
        i0.ɵɵtext(3, "Quickflows");
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(4, "svg", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(5, "div", 2)(6, "div", 3)(7, "div", 4);
        i0.ɵɵtext(8, "Quickflows ");
        i0.ɵɵelementStart(9, "a", 5);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(10, "svg", 6);
        i0.ɵɵelementEnd()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(11, "div", 7);
        i0.ɵɵlistener("click", function QuickflowsMenuComponent_Template_div_click_11_listener() { return ctx.toggleOpenClose(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(12, "svg", 1);
        i0.ɵɵelementEnd()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(13, "div", 8)(14, "div", 9)(15, "ul", 10)(16, "li", 11)(17, "a", 12);
        i0.ɵɵlistener("click", function QuickflowsMenuComponent_Template_a_click_17_listener() { return ctx.toggleQuickflowTab(); });
        i0.ɵɵtext(18, "Single");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(19, "li", 11)(20, "a", 12);
        i0.ɵɵlistener("click", function QuickflowsMenuComponent_Template_a_click_20_listener() { return ctx.toggleQuickflowTab(); });
        i0.ɵɵtext(21, "Comparison");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelement(22, "ycn-single-select-quickflows", 13)(23, "ycn-multi-select-quickflows", 13);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("hidden", ctx.isMenuOpened);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("name", "icon-down-arrow");
        i0.ɵɵadvance();
        i0.ɵɵproperty("hidden", !ctx.isMenuOpened);
        i0.ɵɵadvance(4);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction0(21, _c0));
        i0.ɵɵpropertyInterpolate("href", ctx.userPreferencesUrl, i0.ɵɵsanitizeUrl);
        i0.ɵɵproperty("tooltipTitle", "Quickflow Preferences");
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", "icon-gear");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("name", "icon-close");
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(22, _c1, ctx.showSingleSecurityQuickflowsTab));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(24, _c1, !ctx.showSingleSecurityQuickflowsTab));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("hidden", !ctx.showSingleSecurityQuickflowsTab)("displaySecurityId", ctx.displaySecurityId)("securityId", ctx.securityId)("securityName", ctx.securityName)("securityUrl", ctx.securityUrl);
        i0.ɵɵadvance();
        i0.ɵɵproperty("hidden", ctx.showSingleSecurityQuickflowsTab)("displaySecurityId", ctx.displaySecurityId)("securityId", ctx.securityId)("securityName", ctx.securityName)("securityUrl", ctx.securityUrl);
    } }, dependencies: [i3.NgClass, i4.IconDirective, i5.TooltipDirective, i6.MultiSelectQuickflowsComponent, i7.SingleSelectQuickflowsComponent], encapsulation: 2 });
